import React from 'react'
import style from './NousRejoindre.module.css'
import Typical from 'react-typical'
// import Particles from '../../Particle/ParticleCopy'
import BGNousRejoindre from '../../../assets/BGNousRejoindre.jpg'
// import Form from '../../Form/Form'
// import { useTranslation} from 'react-i18next';
import FormNousContacter from '../../FormNousContacter/FormNousContacter'
// import Tarif from '../../Tarifs/Tarifs'
// import { Divider } from '@material-ui/core'
// import ImgExpo from './pexels-hermaion-205414.jpg'
import OffreTarif from '../../OffreTarif/OffreTarif'




const NousRejoindre = () => {
    // const { t } = useTranslation();
    // const [show, SetShow] = useState(false)
    return (
        <div>
        
            <div className={style.bigContenaire}  style={{backgroundImage: `url(${BGNousRejoindre})`, height: 400+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} >
                <div >
                    <div >
                        
                        <h1 className="text-white">
                            <Typical
                            loop = {1}
                           
                            steps={[
                            `Envie de rejoindre notre réseau d'artistes?` ,2500,]
                            }/> 
                            {/* wrapper= "c" */}
                        </h1>

                        <h1 className={style.green}>
                            <Typical
                            loop = {Infinity}
                            
                            steps={[
                            'Artiste peintre_',1500,
                            'Sculpteur_',1500,
                            'Photographe_',1000,]
                            }/>
                            {/* wrapper= "b" */}
                        </h1>

                    </div>
                </div>
            </div>
            <div>
                <OffreTarif />
            </div>
            

            <div>
                <FormNousContacter />
            </div>
               
        </div>
        
    )
    
}

export default NousRejoindre